import axios from "axios";

/***************************

    Эвентийн тасалбарын тэмдгийг ХАРУУЛАХ эсэх

    Шийдвэрийг СЕРВЭР гаргана (`/api/event/voucher/status`), учир нь
    ваучер олгох шалгалт ч ЯГ ИЖИЛ дүрмээр явдаг (`isSonsyTicket`,
    server/server.js). Хөтөч дээр дүрмийг ДАВХАРДУУЛАН бичвэл хоёр газар
    зөрөх эрсдэлтэй — тэмдэг харагдсан ч ваучер гарахгүй болно.

    Дүрэм (сервер тал):
      тохируулсан тасалбар жагсаалтад БАЙГАА  +  type === "PROMO"
      +  hasSonsy === true  +  hasVoucher === true

    Тодорхойгүй/алдаатай бүх тохиолдолд `false` — амлаад биелүүлэхгүй
    байхаас тэмдгийг нуух нь дээр.

***************************/

// Нэг хуудас ачаалалд НЭГ л удаа асууна (хоёр карт зэрэг асуувал давхарлана)
let inFlight = null;
let cached = null;

/**
 * @param {{eventId: string, ticketId: string}|null} eventLink
 * @returns {Promise<boolean>}
 */
export const fetchEventVoucherAvailable = (eventLink) => {
  const params = eventLink
    ? `?eventId=${encodeURIComponent(eventLink.eventId)}&ticketId=${encodeURIComponent(eventLink.ticketId)}`
    : "";

  // Хам сурвалж өөрчлөгдвөл кэш хүчингүй
  const key = params || "default";
  if (cached && cached.key === key) return Promise.resolve(cached.available);
  if (inFlight && inFlight.key === key) return inFlight.promise;

  const promise = axios
    .get(`/api/event/voucher/status${params}`)
    .then((resp) => {
      const available = Boolean(resp.data && resp.data.available);
      cached = { key, available };
      return available;
    })
    .catch((error) => {
      console.error("Failed to read event voucher status", error.message);
      return false;
    })
    .finally(() => {
      inFlight = null;
    });

  inFlight = { key, promise };
  return promise;
};
